module.exports = __webpack_public_path__ + "img/20191101110549微信截图_20191101105736.e3891888.png";